import { KeyRelationship, Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { BuildHexMap} from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { All } from "../../../Util/Constants/Quantities";
import { MutableRefObject, useRef, useState } from "react";
import { produce } from "immer";
import './HexMapNotesChapter.scss'
import { Key } from "../../../Data/HexMap/Key";
import { DotNav } from "../../../Comps/DotNav/DotNav";
export function HexMapNotesChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div className={'hex-map-notes-chapter'}>
                <h1>Note Location in the HexMap</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const radius:number = 70
    const columns:number = 7
    const rows:number = 6
    const width:number = 850
    const height:number = 600
    const tonic:number = Music.Db
    const centerKey:number = 58
    const [scale, setScale] = useState(1.2)
    const getHexMap = () => {  
        const hexMap:HexMap = BuildHexMap({columns:columns, rows:rows, tonic:tonic, radius:radius})
        const mod:HexMapModifier = new HexMapModifier(hexMap)
        const keyIndexes:number[] = [15,16,17,18,22,23,24,25,30,31,32,33] //[43,44,45,46,57,58] //,59,60,70,71,72,73]
        let noteIndexes:number[] = []
        keyIndexes.forEach((keyIndex:number)=>{
            noteIndexes = noteIndexes.concat(hexMap.keys.flat()[keyIndex].noteIndexes)
        })
        mod.keys_setOpen([All], false)
        mod.keys_setDefined([All], false)
        mod.keys_setOpen(keyIndexes, true)
        mod.notes_setDefined([All], true)
        mod.notes_setHalo([All], true)
        //mod.keys_setOpen([All], true)
        //mod.notes_setDefined([All], false)
        //mod.notes_setDefined(noteIndexes, true)
        //mod.notes_addClasses([All], ['disabled'])
        //mod.notes_removeClasses(noteIndexes, ['disabled'])
        mod.keys_addClasses([All], ['disabled'])
        mod.keys_removeClasses(keyIndexes, ['disabled'])
        //mod.notes_setVisible([All], false)
        //mod.notes_setVisible(noteIndexes, true)
        return hexMap
    }
    const [hexMap, setHexMap] = useState(getHexMap())
    const [navIndex, setNavIndex] = useState(0)
    const mod:MutableRefObject<HexMapModifier> = useRef(new HexMapModifier(hexMap))
    const getFilledKeys = (note:Note, hexMap:HexMap) => {
        const filledKeys:number[] = []
        const keyRels:KeyRelationship[] = note.keys
        keyRels.forEach((keyRel:KeyRelationship)=>{
            const keyIndex:number = keyRel.keyIndex
            const key:Key = hexMap.keys.flat()[keyIndex]
            const noteIndexes:number[] = key.noteIndexes
            const definedNotes:number[] = noteIndexes.filter((noteIndex:number)=>{
                return(hexMap.notes[noteIndex].defined)
            })
            if(definedNotes.length === 7){
                filledKeys.push(keyIndex)
            }
        })
        return filledKeys
    }
    const onNoteClick = (note:Note) => {
        const noteIndexes:number[] = [note.params.noteIndex]
        setHexMap(produce((draft:HexMap)=>{ 
                mod.current.setDraft(draft)
                if(note.classNames.includes('disabled')){
                    mod.current.notes_setDefined(noteIndexes, true)
                    mod.current.notes_removeClasses(noteIndexes, ['disabled'])
                }
                else{
                    if(note.selectedState === Note.SelectedState_Hilited){
                        mod.current.notes_setDefault(noteIndexes)
                    }
                    else{
                        mod.current.notes_setHilited(noteIndexes)
                    }
                }
                mod.current.setDraft(draft)
        }))
        return        
    }
    const showHideKey = (key:Key) => {
        const keyIndex:number = key.params.keyIndex
        setHexMap(produce((draft:HexMap)=>{
            mod.current.setDraft(draft)
            const key:Key = draft.keys.flat()[keyIndex]
            if(key.classNames.includes('disabled')) {
                mod.current.keys_removeClasses([keyIndex], ['disabled'])
                mod.current.keys_setOpen([keyIndex], true)
                mod.current.notes_setDefined(key.noteIndexes, true)
                mod.current.notes_removeClasses(key.noteIndexes, ['disabled'])
            }
            else{
               if(key.selectedState === Note.SelectedState_Default){
                    mod.current.keys_setSelected([key.params.keyIndex])
               }
               else{
                    mod.current.keys_setDefault([key.params.keyIndex])
               }

            }
            mod.current.setDraft(draft)
        }))
    }
    const onKeyClick = (key:Key) => {
        showHideKey(key)
    }       

    return(
        <OutlineBox title={'The Three instances of each note in the HexMap: Odd, Even and Seventh'} width={width}>
            <div className={'Lesson'}>
                <svg className={'hex-map-svg'} width={width} height={height}>
                    <g transform={TransformTranslate(width/2, height/2)}>
                        <g className={'scale'} style={{scale:scale}}>
                        <HxMapGroup onNoteClick={onNoteClick}
                                    onKeyClick={onKeyClick} 
                                    hexMap={hexMap}/>
                        </g>
                    </g>
                </svg>
            </div>
 
        </OutlineBox>
    )
}
